import React from 'react'
import SliderInside from '../components/slider_inside'
import OtherProjects from '../components/other_projects'
import BoxProject from '../components/box_project'

// Assets
import Image1 from '../assets/images/projects/miles/diseno-web-miles-001.webp'
import Image2 from '../assets/images/projects/miles/diseno-web-miles-002.webp'
import Image3 from '../assets/images/projects/miles/diseno-web-miles-003.webp'
import Image4 from '../assets/images/projects/miles/diseno-web-miles-004.webp'
import Image5 from '../assets/images/projects/miles/diseno-web-miles-005.webp'
import Image6 from '../assets/images/projects/miles/diseno-web-miles-006.webp'
import imageSlider from '../assets/images/projects/miles/slide.webp'

class Miles extends React.Component {
	componentDidMount() {
		window.scrollTo(0, 0)
	}

	render() {
		return (
			<>
				<SliderInside
					service="web"
					project="miles"
					name="MILES CAR RENTAL"
					description="
					<b class='badge badge--web'>UX UI</b>
					<b class='badge badge--branding'>Marca</b>
					<b class='badge badge--system'>Design System</b>
					<b class='badge badge--layout'>Maquetación</b>
					"
					img={imageSlider}
				/>

				<section className="container-fluid bg-overlay-site position-relative z2">
					<div className="row justify-content-center services-gallery">
						<BoxProject
							elementType="image"
							elementSrc={Image1}
							layout="col-12 none-info"
						/>

						<BoxProject
							elementType="image"
							elementSrc={Image2}
							layout="col-12 none-info"
						/>

						<BoxProject
							elementType="image"
							elementSrc={Image3}
							layout="col-12 none-info"
						/>

						<BoxProject
							elementType="image"
							elementSrc={Image4}
							layout="col-12 none-info"
						/>

						<BoxProject
							elementType="image"
							elementSrc={Image5}
							layout="col-12 none-info"
						/>

						<BoxProject
							elementType="image"
							elementSrc={Image6}
							layout="col-12 none-info"
						/>
					</div>

					<div className="col-12">
						<div className="d-flex justify-content-center box-btn mt-4 pb-3 pb-md-4">
							<a className="buttom btn-quote" rel="model">Cotiza tu Proyecto</a>
						</div>
					</div>

					<OtherProjects
						type='web'
						noPrint='miles'
					/>

				</section>
			</>
		);
	}
}

export default Miles;